module.exports = __webpack_public_path__ + "img/dynamic-19.7bd034c4.png";